export default "/images/9c7531de0ca0a5d53540f63fc4a4399b.avif";